import React from "react";
import { Table, Title } from "melco-ui"; // your styled Table component
import type { ColumnsType } from "antd/es/table";
import type { ControlcenterMelcoModelsMachineLicensePricingInfo as PricingInfo } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

interface MachineLicensesChangeRow {
    key: string;
    title: string;
    current: string;
    new: string;
    change: string;
}

interface Props {
    response: {
        monthly?: PricingInfo;
        yearly?: PricingInfo;
    };
}


// Safe formatter
const formatCurrency = (value?: number) =>
    value !== undefined ? `$${value.toFixed(2)}` : "-";


const ChangeMachineLicensesChangeTable: React.FC<Props> = ({ response }) => {
    const { t } = useTranslation()
    // Build row data
    const buildTableData = (
        data: PricingInfo,
        period: "month" | "year"
    ): MachineLicensesChangeRow[] => {
        const currentLic = data.current_licenses_count ?? 0;
        const newLic = data.new_licenses_count ?? 0;
        const currentCost = data.current_total_cost ?? 0;
        const newCost = data.new_total_cost ?? 0;

        return [
            {
                key: "licenses",
                title: t("machinelicenses.change.changetable.amount_of_licenses"),
                current: data.current_licenses_count?.toString() ?? "-",
                new: data.new_licenses_count?.toString() ?? "-",
                change: `${newLic - currentLic >= 0 ? "+" : ""}${newLic - currentLic} licenses`,
            },
            {
                key: "cost",
                title: t("machinelicenses.change.changetable.cost"),
                current: `${formatCurrency(data.current_total_cost)} / ${period}`,
                new: `${formatCurrency(data.new_total_cost)} / ${period}`,
                change: `${newCost - currentCost >= 0 ? "+" : ""}${formatCurrency(newCost - currentCost)} / ${period}`,
            },
        ];
    };

    const columns: ColumnsType<MachineLicensesChangeRow> = [
        {
            title: "",
            dataIndex: "title",
            key: "title",
        },
        {
            title: t("machinelicenses.change.changetable.current"),
            dataIndex: "current",
            key: "current",
        },
        {
            title: t("machinelicenses.change.changetable.new"),
            dataIndex: "new",
            key: "new",
        },
        {
            title: t("machinelicenses.change.changetable.change"),
            dataIndex: "change",
            key: "change",
        },
    ];
    return (
        <>

            {response.monthly && (
                <>
                    <Title level={5}>{t("machinelicenses.change.changetable.monthly")}</Title>
                    <Table
                        columns={columns}
                        dataSource={buildTableData(response.monthly, "month")}
                        pagination={false}
                        bordered
                    />
                </>
            )}

            {response.yearly && (
                <>
                    <Title level={5} style={{ marginTop: 24 }}>{t("machinelicenses.change.changetable.yearly")}</Title>
                    <Table
                        columns={columns}
                        dataSource={buildTableData(response.yearly, "year")}
                        pagination={false}
                        bordered
                    />
                </>
            )}
        </>
    );
};

export default ChangeMachineLicensesChangeTable;